import { updateItems } from '@/mocks/homeData';

function getTagClass(tag: string) {
  switch (tag) {
    case '最新': return 'bg-primary-500 text-background-50';
    case '突发': return 'bg-primary-500 text-background-50';
    case '热议': return 'bg-accent-500 text-background-50';
    case '爆料': return 'bg-primary-100 text-primary-700';
    case '跟进': return 'bg-secondary-100 text-secondary-700';
    case '深度': return 'bg-accent-100 text-accent-700';
    case '辟谣': return 'bg-secondary-100 text-secondary-700';
    default: return 'bg-secondary-100 text-secondary-700';
  }
}

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100/80 mb-4">
            <i className="ri-timer-flash-line text-primary-600 text-sm"></i>
            <span className="text-primary-700 text-xs font-medium">实时快讯</span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mb-3">
            实时快讯
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            全天候追踪最新爆料，每15分钟更新一次
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-4 md:left-6 top-0 bottom-0 w-0.5 bg-background-200" />

          <div className="space-y-6">
            {updateItems.map((item) => (
              <div key={item.id} className="relative pl-10 md:pl-14 group cursor-pointer">
                <div className="absolute left-2.5 md:left-4.5 top-1.5 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-50 ring-2 ring-primary-100 transition-all group-hover:scale-125" />

                <div className="bg-background-50 border border-background-200/70 rounded-xl p-4 md:p-5 transition-all duration-200 hover:border-primary-200 hover:-translate-y-0.5">
                  <div className="flex flex-wrap items-center gap-2 md:gap-3 mb-2">
                    <span className={`text-xs font-bold px-2 py-0.5 rounded ${getTagClass(item.tag)}`}>
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-400">{item.time}</span>
                    <span className="text-xs text-foreground-400 hidden sm:inline">· {item.source}</span>
                  </div>
                  <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 leading-snug group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}